// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cost-calculator {
    margin: 0 auto;
    padding-top: 20px;
    box-sizing: border-box;
  }
  
  .tabs {
    justify-content: center;
    margin-bottom: 20px;
    width: 100%;
    max-width: 800px;
    margin: 0 auto;
}
  
  
  .tab-button {
    padding: 10px 0px;
    font-size: 1em;
    width:46%;
    color: #555;
    background-color: #fff;
    font-weight: bold;
    border: none;
    border-bottom: 3px solid #CCC;
    cursor: pointer;
    margin: 0 5px;
  }
  
  .tab-button.active {
    border-bottom: 3px solid #007bff;
    color: #007bff;
  }`, "",{"version":3,"sources":["webpack://./src/components/CostCalculator.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,cAAc;AAClB;;;EAGE;IACE,iBAAiB;IACjB,cAAc;IACd,SAAS;IACT,WAAW;IACX,sBAAsB;IACtB,iBAAiB;IACjB,YAAY;IACZ,6BAA6B;IAC7B,eAAe;IACf,aAAa;EACf;;EAEA;IACE,gCAAgC;IAChC,cAAc;EAChB","sourcesContent":[".cost-calculator {\n    margin: 0 auto;\n    padding-top: 20px;\n    box-sizing: border-box;\n  }\n  \n  .tabs {\n    justify-content: center;\n    margin-bottom: 20px;\n    width: 100%;\n    max-width: 800px;\n    margin: 0 auto;\n}\n  \n  \n  .tab-button {\n    padding: 10px 0px;\n    font-size: 1em;\n    width:46%;\n    color: #555;\n    background-color: #fff;\n    font-weight: bold;\n    border: none;\n    border-bottom: 3px solid #CCC;\n    cursor: pointer;\n    margin: 0 5px;\n  }\n  \n  .tab-button.active {\n    border-bottom: 3px solid #007bff;\n    color: #007bff;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
